import React, { useCallback, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../ui/Icon';
import { useKiosk } from './StationApp';
import { usePrint } from './PrintProgress';
import MagazynBoard, { BoardPrintRequest } from '../magazyn/MagazynBoard';
import { stockErrorText } from '../magazyn/api';

/* Magazyn na stacji: dostawy, braki, lista „Do dobrania" i jej rozliczenie.
   Gdy tablica ma niezapisany szkic, stacja jest „zajęta": versionWatcher nie przeładuje
   aplikacji, a auto-wylogowanie czeka (StationApp → useAutoLogout czyta tę samą flagę). */
export default function MagazynScreen() {
  const navigate = useNavigate();
  const { push, flash, compact } = useKiosk();
  const { startPrint } = usePrint();
  const dirty = useRef(false);

  const onDirtyChange = useCallback((d: boolean) => {
    dirty.current = d;
    window.__packflowBusy = d;
    // Odłożone przeładowanie nowej wersji może dojść do skutku, gdy szkic zniknął.
    if (!d) window.dispatchEvent(new Event('packflow:route-changed'));
  }, []);

  useEffect(() => () => {
    window.__packflowBusy = false;
  }, []);

  const onPrint = useCallback((req: BoardPrintRequest) => {
    startPrint({
      title: req.title,
      subtitle: req.subtitle,
      unit: 'page',
      preparing: 'Przygotowanie wydruku…',
      run: async () => {
        try {
          const r = await req.run();
          return r.jobId ? { jobIds: [r.jobId], detail: r.message } : { jobIds: [], info: r.message };
        } catch (e) {
          return { jobIds: [], error: stockErrorText(e) };
        }
      },
    });
  }, [startPrint]);

  function back() {
    // Szkic zostaje w pamięci sesji — po powrocie wszystko czeka tam, gdzie było.
    if (dirty.current) push('Niezapisany szkic zostaje — dokończysz po powrocie', 'info');
    navigate('/packing-station/dashboard');
  }

  return (
    <div className="screen">
      <div className="k-header">
        <button className="back" onClick={back} aria-label="Wróć"><Icon name="arrow-left" size={20} /></button>
        <div>
          <div className="k-title">Magazyn</div>
          <div className="k-sub">Dostawy · braki · dobranie</div>
        </div>
      </div>
      <MagazynBoard
        variant="kiosk"
        compact={compact}
        onPrint={onPrint}
        notify={push}
        flash={flash}
        onDirtyChange={onDirtyChange}
      />
    </div>
  );
}
